
import { RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';

interface RefreshButtonProps {
  onClick: () => void;
}

const RefreshButton = ({ onClick }: RefreshButtonProps) => {
  return (
    <motion.button
      className="mt-4 flex items-center justify-center space-x-2 text-sm text-blue-600 hover:text-blue-800 transition-colors"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8 }}
    >
      <RefreshCw size={14} />
      <span>Get another fortune</span>
    </motion.button>
  );
};

export default RefreshButton;
